import React from 'react';
import Link from 'next/link';
import { Shield, Heart } from 'lucide-react';

export function Footer() {
  return (
    <footer className="border-t border-white/[0.06] bg-brand-surface/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-full bg-brand-lime flex items-center justify-center">
                <span className="text-brand-black font-bold text-sm">SW</span>
              </div>
              <span className="font-semibold text-brand-white tracking-wide">STRANGER WORLD</span>
            </div>
            <p className="text-sm text-brand-gray leading-relaxed max-w-xs">
              A safe, anonymous platform to connect with people from around the world. Real
              conversations. Real connections.
            </p>
            <p className="mt-3 text-[10px] font-semibold tracking-[0.2em] text-brand-gray-muted uppercase">
              Anonymity by Design
            </p>
            <div className="flex items-center gap-2 mt-3 text-xs text-brand-gray">
              <Shield size={12} className="text-brand-lime" />
              <span>Moderated & Safe Platform</span>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm font-semibold text-brand-white mb-4">Product</h4>
            <ul className="flex flex-col gap-2">
              {[
                { href: '/chat', label: 'Start Chatting' },
                { href: '/subscribe', label: 'Premium' },
                { href: '/#how-it-works', label: 'How it Works' },
                { href: '/#safety', label: 'Safety' },
              ].map(({ href, label }) => (
                <li key={href}>
                  <Link
                    href={href}
                    className="text-sm text-brand-gray hover:text-brand-lime transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-brand-white mb-4">Support</h4>
            <ul className="flex flex-col gap-2">
              {[
                { href: '/support', label: 'Help Center' },
                { href: '/support#faq', label: 'FAQ' },
                { href: '/support#contact', label: 'Contact Us' },
                { href: '/login', label: 'Sign In' },
              ].map(({ href, label }) => (
                <li key={href}>
                  <Link
                    href={href}
                    className="text-sm text-brand-gray hover:text-brand-lime transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-brand-gray">
            &copy; {new Date().getFullYear()} Stranger World. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link href="#" className="text-xs text-brand-gray hover:text-brand-lime transition-colors">
              Privacy Policy
            </Link>
            <Link href="#" className="text-xs text-brand-gray hover:text-brand-lime transition-colors">
              Terms of Service
            </Link>
          </div>
          <p className="text-xs text-brand-gray flex items-center gap-1">
            Made with <Heart size={10} className="text-brand-red" fill="currentColor" /> for global connections
          </p>
        </div>
      </div>
    </footer>
  );
}
